export class Sucursal {
    idSucursal: number;
    clave: string;
    descripcion: string;
    direccion: string;
    telefono: string;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/sucursal.ts